export default "./images/survio-xTnG8-assets-custom_text.png";